import React from 'react'
import GiftingHead from './GiftingHead'
import HaldiGallery from '../Haldi/HaldiGallery';
import GiftingLuxury from './GiftingLuxury';
import GiftingArt from './GiftingArt';
import GiftingVideo from './GiftingVideo';

export default function Gifting() {

  const haldigallery = [
      { src: "../image/giftgallery-1.webp"},
      { src: "../image/giftgallery-2.webp"},
      { src: "../image/giftgallery-3.webp"},
      { src: "../image/giftgallery-4.webp"},
      { src: "../image/giftgallery-5.webp"},
  ];

  return (
    <>
      <section className='giftpage-head'><GiftingHead/></section>
      <GiftingArt/>
      <GiftingVideo/>
      <GiftingLuxury/>
      <section className='giftpage-gallery'><HaldiGallery haldigallery={haldigallery}/></section>
    </>
  )
}
